import { ContainerModule } from '@evertel/di'
import { CurrentUserEmojisController } from './controller'

const DI_MODULES = [
    new ContainerModule((m) => {
        m.bind(CurrentUserEmojisController).toSelf()
    })
]

export { DI_MODULES }
